export const ts = {
    EMPLOYEE_MY_PASS: {
        description: 'new grid title',
        primaryValue: 'My Pass',
        stringKey: 'EMPLOYEE_MY_PASS',
    }

};

